// extracted by mini-css-extract-plugin
export default {"documentationLink":"dDT4j3MwLVvU3lAv3Og2","documentationLinkIcon":"_7SjOjdFKB5zqv1bKtx3"};